export function getDateFacetSetSliceInitialState(request) {
    return { request };
}
export function getDateFacetSetInitialState() {
    return {};
}
